module.exports = __webpack_public_path__ + "static/media/promo.7f957fc8.png";